const songs = [
  {
    title: "Yam - Heart Chakra",
    artist: "Meditation",
    seconds: 633,
    cover: require("../assets/images/Yam.jpg"),
    src: require("../assets/audios/Yam.mp3")
  },
  {
    title: "Ham - Throat Chakra",
    artist: "Meditation",
    seconds: 633,
    cover: require("../assets/images/Ham.jpg"),
    src: require("../assets/audios/Ham.mp3")
  },
  {
    title: "Om - Agna Chakra",
    artist: "Human Chakras",
    seconds: 633,
    cover: require("../assets/images/Om.jpg"),
    src: require("../assets/audios/Om.mp3")
  },
];

export default songs;
